import { useEffect, useState } from 'react'
import useJsonStorage from './useJsonStorage'

export default function useRedirectStorage(path) {
  const [getRedirect, setRedirectStorage, clearRedirectStorage] =
    useJsonStorage('redirect')
  const [redirect, setRedirect] = useState(() => getRedirect())

  useEffect(() => {
    if (path != null) {
      setRedirectStorage({ path })
      setRedirect({ path })
    }
  }, [path])

  const clearRedirect = () => {
    clearRedirectStorage()
    setRedirect(null)
  }

  return {
    redirect: redirect?.path,
    setRedirect,
    clearRedirect,
  }
}
